module.exports = __webpack_public_path__ + "e44d234030ee6937201b9e4f4d6c5f9c.pdf";